import React, { FC } from "react";
import { FormFieldProps } from "../../utils/formFields";
import FormTextField from "./formfields/FormTextField";
import FormPasswordField from "./formfields/FormPasswordField";
import FormCheckboxField from "./formfields/FormCheckboxField";
import FormSelectField from "./formfields/FormSelectField";
import FormDateField from "./formfields/FormDateField";
import BasicChips from "./formfields/BasicChips";
import MultipleSelectNative from "./formfields/MultipleSelectNative";
import DateRangeFieldNew from "./formfields/DateRangeFieldNew";
import FormCounterField from "./formfields/FormCounterField";
import FormTextAreaField from "./formfields/FormTextAreaField";
import FormRadioField from "./formfields/FormRadioField";
import FormTitleField from "./formfields/FormTitleField";
import FormLabelValueField from "./formfields/FormLabelValueField";
import FormRatingField from "./formfields/FormRatingField";
import CKEditorComponent from "./formfields/CKEditorComponent";
import FormContactTextField from "./formfields/FormContactTextField";
import FormTimeField from "./formfields/FormTimeField";
import FormViewTextField from "./formfields/FormViewTextField";
import FormEditorComponents from "./formfields/FormEditorComponents";
import DateRangeField from "./formfields/DateRangeField";
import FormFieldView from "./formfields/FormFieldView";
import FormMultiChipCheckbox from "./formfields/FormMultiChipCheckbox";
import FormMultiSelectCheckboxField from "./formfields/FormMultiSelectCheckboxField";
import FormChipEmailField from "./formfields/FormChipEmailField";
import FormChipTextField from "./formfields/FormChipTextField";
import FormSuggestionTextField from "./formfields/FormSuggestionTextField";
import FormTimeRangeField from "./formfields/FormTimeRangeField";

const FormField: FC<FormFieldProps> = (props) => {
  const renderField = () => {
    
    switch (props?.type) {
      case "password":
        return <FormPasswordField {...props} />;
      case "checkbox":
        return <FormCheckboxField {...props} />;
      case "radio":
        return <FormRadioField {...props} />;
      case "select":
        return <FormSelectField {...props} />;
      case "multiselectcheckbox":
        return <FormMultiSelectCheckboxField {...props} />;
      case "counter":
        return <FormCounterField {...props} />;
      case "multiselect":
        return <MultipleSelectNative {...props} />;
      case "date":
      case "date-time":
        return <FormDateField {...props} />;
      case "time":
        return <FormTimeField {...props} />;
      case "timerange":
        return <FormTimeRangeField {...props} />;
      case "daterange":
        return <DateRangeFieldNew {...props} />;
      case "daterangebothvalue":
        return <DateRangeField {...props} />;
      case "chip":
        return <BasicChips {...props} />;
      case 'multiSelectChip':
        return <FormMultiChipCheckbox {...props} />;
      case "textarea":
        return <FormTextAreaField {...props} />;
      case "chipText":
        return <FormChipTextField {...props} />;
      case "title":
        return <FormTitleField {...props} />;
      case "labelWithValue":
        return <FormLabelValueField {...props} />;
      case "rating":
        return <FormRatingField {...props} />;
      case "editor":
        return <FormEditorComponents {...props} />;
      case "richtext":
        return <CKEditorComponent {...props} />;
      case "contact":
        return <FormContactTextField {...props} />;
      case "viewField":
        return <FormFieldView {...props} />;
      case "viewTextField":
        return <FormViewTextField {...props} />;
      case "emailChip":
        return <FormChipEmailField {...props} />;
        case "suggestionText":
          return <FormSuggestionTextField {...props} />;
      default:
        return <FormTextField {...props} />;
    }
  };
  return <>{renderField()}</>;
};

export default FormField;
